
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nft-dao",
      function () {
        return require("private-next-pages/nft-dao.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nft-dao"])
      });
    }
  